<template>    
  <v-hover v-slot="{ hover }">  
  <v-container class="saved" :class="{ 'show-btns': hover }">
    <v-card-title class="justify-center text-justify subtitle-2 py-0">
      <p
        class="node-name-label d-flex text-truncate justify-center align-center py-0 my-0"
      >
        {{ onNamenode }}
      </p>
    </v-card-title>
    
    <v-divider class="mx-4"></v-divider>

    <v-container class="py-0">
      <!-- Messages List -->
      <v-row>
        <v-col class="pb-0">
          <div class="d-flex flex-column">
            <span v-if="onActions.length > 0">
              <div class="d-flex align-center" v-for="(action, i) in onActions" :key="i">    
                  <span v-if="action.actionType !== 'vikyAction'" >
                    <strong class="text-capitalize blue--text">{{ action.actionType + " : "}} </strong>
                    <span>  {{ action.name}} </span>
                  </span>
                  <span v-if="action.actionType === 'vikyAction'" class="font-weight-bold text-capitalize red--text">
                    {{action.name}} 
                  </span > 
              </div>
            </span>
            <span v-if="onActions.length === 0">
              <span class="d-flex justify-center">
                <strong>[ No Added Actions ]</strong>
              </span>
            </span >
          </div>
        </v-col>
      </v-row>
    </v-container>
    
    <br>
    <v-divider class="mx-4"></v-divider>

    <v-container class="py-0">
      <!-- Anchors List -->
      <v-row>
        <v-col class="pb-0">
          <div class="d-flex flex-column">
            <span v-if="onAnchors.length > 1">
              <div class="d-flex align-center"  v-for="(anchor, i) in onAnchors" :key="i">    
                <span v-if="anchor.name !== 'in' && anchor.name !== 'default' "> 
                  <strong class="purple--text">Anchor {{i-1}} : </strong> {{ anchor.name }} 
                  <span v-if="anchor.variable.includes('context.state')" class="small">
                    ({{anchor.variable.split('state.')[1]}})
                  </span>
                </span> 
              </div>
            </span>
            <span v-if="(onAnchors.length === 1 && !onAnchors.filter((x) => x.name === 'in').length) || 
              (onAnchors.length === 2 && onAnchors.filter((x) => x.name === 'in').length)">
              <span class="d-flex justify-center">
                <strong>[ No Added Anchors ]</strong>
              </span>
            </span>
          </div>
        </v-col>
      </v-row>
    </v-container>

  </v-container>
  </v-hover>
</template>

<script>

import 'vue-prism-editor/dist/prismeditor.min.css';
import 'prismjs/components/prism-clike';
import 'prismjs/components/prism-javascript';
import 'prismjs/themes/prism-tomorrow.css';

export default {
  props: {
    onNamenode: String,
    onActions: {
      actionType: String,
      name : String,
    },
    onAnchors: {
      name: String
    }, 
  },
  data() {
    return {
      transparent: 'rgba(255, 255, 255, 0)',
    };
  }
};
</script>


<style scoped>

.small{
  font-size: 11px;
}
.saved{
  box-shadow: 0 0 2px 0.1px grey;
}
.v-card {
  transition: opacity .4s ease-in-out;
}
.v-card:not(.on-hover) {
  opacity: 0.6;
 }
.show-btns {
  color: rgba(0, 0, 0, 1) !important;
}


</style>
